import React, { memo } from 'react';
import { View, TextInput, TouchableOpacity, StyleSheet } from 'react-native';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { CORK_BOARD_INPUT_LIMITS } from '@/constants/residents/corkBoardConstants';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

interface NewsfeedSearchBarProps {
  value: string;
  onChangeText: (text: string) => void;
  onClear: () => void;
}

export const NewsfeedSearchBar: React.FC<NewsfeedSearchBarProps> = memo(({
  value,
  onChangeText,
  onClear,
}) => {
  const { colors } = useThemeColors();

  return (
    <View style={[styles.container, { backgroundColor: colors.glass.buttonBg, borderColor: colors.glass.buttonBorder }]}>
      <RESIDENTS_SVG_COMPONENTS.MAGNIFYING_GLASS width={18} height={18} color={colors.text.dimmer} />
      <TextInput
        style={[styles.input, { color: colors.text.primary }]}
        value={value}
        onChangeText={onChangeText}
        placeholder="Search posts..."
        placeholderTextColor={colors.text.dimmer}
        maxLength={CORK_BOARD_INPUT_LIMITS.searchMax}
        returnKeyType="search"
        autoCapitalize="none"
        autoCorrect={false}
        accessibilityLabel="Search community board posts"
        accessibilityRole="search"
      />
      {value.length > 0 && (
        <TouchableOpacity
          style={styles.clearButton}
          onPress={onClear}
          activeOpacity={0.7}
          accessibilityRole="button"
          accessibilityLabel="Clear search"
        >
          <RESIDENTS_SVG_COMPONENTS.CANCEL_X width={14} height={14} color={colors.text.dimmer} />
        </TouchableOpacity>
      )}
    </View>
  );
});

NewsfeedSearchBar.displayName = 'NewsfeedSearchBar';

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderRadius: 12,
    paddingLeft: 17,
    paddingRight: 12,
    height: 44,
    gap: 10,
  },
  input: {
    flex: 1,
    fontSize: 14,
    paddingVertical: 0,
  },
  clearButton: {
    padding: 4,
  },
});
